// import { required, helpers } from 'vuelidate/lib/validators';
import { required } from 'vuelidate/lib/validators';


// const greaterThan = (levelKey) => 
//   helpers.withParams(
//     { type: 'greaterThan', levelKey },
//     (value, parentVm) => {
//       if (!value || !parentVm[levelKey]) return true; // Skip validation if either value is missing
//       return Number(value) > Number(parentVm[levelKey]);
//     }
//   );

const superBonusValidations = {
    dateFrom:  {
        required,
      },
    dateTo:  {
        required,
      },
    // firstLevel:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //   },
    // firstDiscount:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //   },
    // secondLevel:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('firstLevel'), 
    //   },
    // secondDiscount:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('firstDiscount'), 
    //   },
    // thirdLevel:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('secondLevel'), 
    //   },
    // thirdDiscount:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('secondDiscount'), 
    //   },
    // fourthLevel:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('thirdLevel'), 
    //   },
    // fourthDiscount:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('thirdDiscount'), 
    //   },
    // fifthLevel:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('fourthLevel'), 
    //   },
    // fifthDiscount:  {
    //     required,
    //     numeric: helpers.regex('numeric', /^[0-9]*$/),
    //     greaterThanSecond: greaterThan('fourthLevel'), 
    //   },
};

export default superBonusValidations;